import React, { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import cls from 'classnames';

import addDays from 'date-fns/addDays';
import startOfToday from 'date-fns/startOfToday';

import OTTDatePicker from '@ott/datepicker';

import { FIELDS } from '../../constants';
import { SearchForm } from '../../types';

import styles from './Datepicker.scss';

const meta = {};

type Props = {
  className?: string;
  onDateSelect: () => void;
};

const Datepicker = ({ onDateSelect, className }: Props) => {
  const { control } = useFormContext<SearchForm>();
  const { field: dateField } = useController({
    name: FIELDS.DATE,
    control,
  });

  useEffect(() => {
    // Проставляю дефолтное значение через useEffect, чтобы оно не проставлялось на ssr.
    // Если передавать дефолтное значение через defaultValue в useController, то
    // на ssr проставляется дата формирования билда и затем на клиенте происходит фликер
    dateField.onChange(addDays(startOfToday(), 1));
  }, []);

  return (
    <OTTDatePicker
      childrenClassNames={{
        container: cls(styles.datepicker, className),
        input: styles.datepickerInput,
      }}
      closeAfterSelect={true}
      endOnlyAfterStart={true}
      errorPlacement="top"
      input={{ name: FIELDS.DATE, value: { startDate: dateField.value } }}
      meta={meta}
      pickOneDate={true}
      placeholder="Дата поездки"
      onDateSelect={(date: Date) => {
        dateField.onChange(date);
        onDateSelect();
      }}
    />
  );
};

export default React.memo(Datepicker);
